import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrgDeleteDepartmentModalComponent } from './org-delete-department-modal.component';
import { BannerModule, ButtonModule, DropdownModule } from '@xref/xref-lib';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';



@NgModule({
  declarations: [OrgDeleteDepartmentModalComponent],
  imports: [
    CommonModule,
    DropdownModule,
    ButtonModule,
    BannerModule,
    NgbModule,
    BsDropdownModule.forRoot(),
  ]
})
export class OrgDeleteDepartmentModalModule { }
